import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/imgs/logo.png';
import _imports_1 from '@/assets/imgs/user.png';
const _hoisted_1 = {
  class: "header-middle"
};
const _hoisted_2 = {
  class: "menu-left"
};
const _hoisted_3 = {
  class: "menu-right"
};
const _hoisted_4 = {
  key: 0,
  class: "user-action"
};
const _hoisted_5 = {
  class: "user-info"
};
import { computed, reactive, onMounted, inject, ref } from 'vue';
import { CommonStore } from '@/store/modules/common';
import { MenuBlackList } from '@/utils/const';
import { getToken } from '@/utils/util';
import LangList from '@/i18n/lang-list';
import { useRouter, useRoute, onBeforeRouteUpdate } from 'vue-router';
import Menus from './Menus.vue';
import AccountApi from '@/api/account';
import to from 'await-to-js';
// 翻译渠道动态菜单集合
import { baiduNav } from './baiduNav';
import { sogouNav } from './sogouNav';
import { defaultNav } from './defaultNav';
export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {
    const common = CommonStore();
    const router = useRouter();
    const route = useRoute();
    const langList = LangList;
    const changeLang = inject('changeLang');
    const currentLang = ref('');
    const state = reactive({
      soloModuleName: ''
    });
    const menuAll = {
      'home-06': baiduNav,
      'home-08': sogouNav,
      home: defaultNav
    };
    onMounted(() => {
      updateSoloModuleName(route);
      currentLang['value'] = localStorage.getItem('languageKey');
    });
    // 判断是否登录
    const isLogin = computed(() => {
      return getToken();
    });
    // 获取显示状态的路由
    const menuLists = computed(() => {
      const channel = localStorage.getItem('channel') || 'home';
      const menus = menuAll[channel];
      return menus;
    });
    const toMachinePage = () => {
      window.location.href = '/client/machineOrder';
    };
    const switchLang = key => {
      changeLang(key);
      currentLang['value'] = key;
    };
    const toHome = () => {
      router.push('/home');
    };
    // 获取路由列表
    const getMenus = () => {
      var _router$options;
      let menuList = [];
      const routes = ((_router$options = router.options) === null || _router$options === void 0 ? void 0 : _router$options.routes) || [];
      routes.some(item => {
        if (item.path == '/') {
          menuList = item.children || [];
          return true;
        }
      });
      return JSON.parse(JSON.stringify(menuList));
    };
    const toHref = href => {
      window.location.href = href;
      // window.history.pushState(null, '', href)
    };
    // action点击
    const handleCommand = command => {
      switch (command) {
        case 'order':
          // window.history.pushState({}, '', '/client/order')
          window.location.href = '/client/orderCenter';
          break;
        case 'wallet':
          window.location.href = '/client/myWallet';
          break;
        case 'account':
          window.location.href = '/client/accountSecurity';
          break;
        case 'exit':
          handleExit();
          break;
        default:
          break;
      }
    };
    // 退出登录
    const handleExit = async () => {
      await to(AccountApi.loginOut({}));
      localStorage.setItem('clientLoginInfo', '{}');
      common.setInitSys();
    };
    const updateSoloModuleName = data => {
      var _data$meta;
      if ((_data$meta = data.meta) !== null && _data$meta !== void 0 && _data$meta.hidden && !MenuBlackList.includes(data.path)) {
        var _data$meta2;
        state.soloModuleName = (_data$meta2 = data.meta) === null || _data$meta2 === void 0 ? void 0 : _data$meta2.title;
      }
    };
    onBeforeRouteUpdate(to => {
      updateSoloModuleName(to);
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_CaretBottom = _resolveComponent("CaretBottom");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
        class: "logo-img",
        src: _imports_0,
        onClick: toHome
      }), _withDirectives(_createElementVNode("span", {
        class: "current-module"
      }, _toDisplayString(state.soloModuleName), 513), [[_vShow, state.soloModuleName]]), _withDirectives(_createVNode(Menus, {
        "menu-lists": menuLists.value
      }, null, 8, ["menu-lists"]), [[_vShow, !state.soloModuleName]])]), _createElementVNode("div", _hoisted_3, [!isLogin.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = $event => toHref('/client/register'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.text2')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => toHref('/client/login'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.text1')), 1)]),
        _: 1
      })])) : (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 1,
        "popper-class": "drop-down-popper",
        onCommand: handleCommand
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            command: "order"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.text13')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "wallet"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.text14')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "account"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.text15')), 1)]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "exit"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('menu.text16')), 1)]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "user-img",
          src: _imports_1
        }, null, -1)), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
          _: 1
        })])]),
        _: 1
      }))])]);
    };
  }
});